<template>
  <div id="shop-view">
    <!--<Shop :content="contentWithEvents" infoText="Vous pouvez bénéficier d'un tarif préférentiel à partir de 4 personnes."
      checkoutUrl="checkout" api="city-aventure-saintefoy" wordFilter=""/>-->
      SHOP
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      content: {

      },
    };
  },
  computed: {
    contentWithEvents() {
      return {
        ...this.content,
        calendar: [
          {
            color: {
              color: "#551A90",
            },
            title: "Nocturnes Halloween",
            events: [
              {
                "date": "2022-10-29",
                "title": "",
              },
              {
                "date": "2022-10-30",
                "title": "",
              },

            ],
          },
          {
            color: {
              color: "#f97901",
            },
            title: "Nocturnes Halloween + concours de déguisement",
            events: [
              {
                "date": "2022-10-31",
                "title": "",
              },

            ],

          },
        ],
      }
    }
  },
  mounted() { },
};
</script>

<style lang="scss">
.shop .footer-first,
.shop-albigny .footer-first {
  display: none;
}
.caption-calendar {
  flex-wrap: wrap;
}
</style>
